class ClaimSmeltedItemRewardsCommand {
	static protocol = {}

	constructor() {}
}

export default ClaimSmeltedItemRewardsCommand
